import React, { createContext, ReactNode, useContext, useState } from "react";
import { Snackbar } from "@mui/material"; // Importar Snackbar do Material UI
import MuiAlert, { AlertProps } from "@mui/material/Alert"; // Importar Alert do Material UI

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

interface IResponse {
  id: number;
  message: string;
  severity: "success" | "error" | "info"; // Tipos de severidade
}

interface IResponseContextData {
  responses: IResponse[];
  addResponse: (message: string, severity?: "success" | "error" | "info") => void;
  removeResponse: (id: number) => void;
}

const ResponseContext = createContext({} as IResponseContextData);

interface IResponseProviderProps {
  children: ReactNode;
}

function ResponseProvider({ children }: IResponseProviderProps) {
  const [responses, setResponses] = useState<IResponse[]>([]);
  const [openResponses, setOpenResponses] = useState<{ [key: number]: boolean }>({}); // Estado para controlar abertura de cada Snackbar

  const addResponse = (message: string, severity: "success" | "error" | "info" = "info") => {
    const exists = responses.some((response) => response.message === message);
    if (!exists) {
      const id = new Date().getTime();
      setResponses((prev) => [...prev, { id, message, severity }]);
      setOpenResponses((prev) => ({ ...prev, [id]: true })); // Definir o Snackbar específico como aberto
    }
  };

  const removeResponse = (id: number) => {
    setOpenResponses((prev) => ({ ...prev, [id]: false })); // Definir o Snackbar específico como fechado
    // setTimeout(() => {
    //   setResponses((prev) => prev.filter((response) => response.id !== id)); // Remover da lista após o fechamento
    // }, 500);
  };

  return (
    <ResponseContext.Provider value={{ responses, addResponse, removeResponse }}>
      {children}
      <div style={{ position: "fixed", top: 20, left: 0, right: 0, zIndex: 1000 }}>
        {responses.map((response, index) => (
          <Snackbar
            key={response.id}
            open={openResponses[response.id] || false} // Verificar se o Snackbar específico está aberto
            // autoHideDuration={5000}
            // onClose={() => removeResponse(response.id)} // Fechar apenas o Snackbar específico
            anchorOrigin={{ vertical: "top", horizontal: "center" }} // Anexar ao centro na parte superior
            style={{ marginTop: index * 70 }} // Espaçamento entre as mensagens
          >
            <Alert
              onClose={() => removeResponse(response.id)} // Fechar apenas o Alert específico
              severity={response.severity}
              sx={{ width: "600px", maxWidth: "100vw" }} // Define uma largura fixa para o Snackbar
            >
              {response.message}
            </Alert>
          </Snackbar>
        ))}
      </div>
    </ResponseContext.Provider>
  );
}

function useResponse() {
  const context = useContext(ResponseContext);
  if (!context) {
    throw new Error("useResponse must be used within a ResponseProvider");
  }
  return context;
}

export { ResponseProvider, useResponse };
